export default "__VITE_ASSET__i5yuhHUt__"